
export abstract class IconBase  {

  protected getSizeStyle(size: string): { width: string; height: string } | undefined {
    const sizes: Array<string> = size.split('x');
    let width: string;
    let height: string;

    if (sizes.length === 1) {
      width = height = isNaN(Number(sizes[0])) ? sizes[0] : `${sizes[0]}px`;
    } else {
      width = isNaN(Number(sizes[0])) ? sizes[0] : `${sizes[0]}px`;
      height = isNaN(Number(sizes[1])) ? sizes[1] : `${sizes[1]}px`;
    }
    return { width, height };
  }

}
